module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/slider/10.jpg";